const BaseView = require('./logo-type');

module.exports = BaseView.extend({
  type: 'icon',
  template: require('./icon-type.hbs'),
  ElementListView: require('./element-list/icons-view'),
  basicHide: ['icon_colour', 'icon_add', 'icon_replace', 'icon_position', 'icon_z_index'],

  selectSpecifyFolder: function () {
    document.querySelector('#element-restrictions-source').checked = false;
    document.querySelector('#element-restrictions-folder').checked = true;
    const sourceList = this.el.querySelector('.icon-replacement-options');
    const folderList = this.el.querySelector('.icon-replacement-folders');
    sourceList.classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', false);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-folder'));
  },

  selectSpecifySource: function () {
    document.querySelector('#element-restrictions-source').checked = true;
    document.querySelector('#element-restrictions-folder').checked = false;
    const sourceList = this.el.querySelector('.icon-replacement-options');
    const folderList = this.el.querySelector('.icon-replacement-folders');
    sourceList.classList.toggle('hidden', false);
    folderList.classList.toggle('hidden', true);
    this.initAddButton();
    this.logosListView.addElement(this.selection.source);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
  },

  getTypeFilterRegex: function () {
    return /^icon_/;
  },

  renderDisabled: function () {
    this._renderColorDisabled();
    BaseView.prototype.renderDisabled.apply(this, arguments);
  },

  _renderColorDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restrictions-color-content');

    if (!replaceColorInput) return;

    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    this.el.querySelector('div[data-name="colors"]').classList.toggle('hidden', !isReplaceOn);
    this.el.querySelector('div[data-name="colors-library"]').classList.toggle('hidden', !isReplaceOn);

    const replaceColorSubInput = document.querySelector('#element-restrictions-colors');

    if (!replaceColorSubInput) return;

    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    this.el.querySelector('.color-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));

    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-colors-library');

    if (!replaceColorPaletteSubInput) return;

    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));
    this.el.querySelector('.palette-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
  }
});
